<template>
  <div class="app-mail_aml" :class="{ [curTheme]: true }">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`mail-group-${i}`"
        class="input-group">

        <div class="aml_block-wrap">

          <div class="aml_block aml_block--mail">
            <el-input
              v-model="valueLocal[i].mail"
              v-bind="widgetOptions"
              :class="{ 'child-has-error': error[i].mail }"
              @input="initChangeTimer(i)"
              placeholder="Почтовый ящик"
              :key="`mail-mail-${i}`">
              <template slot="append">@</template>
            </el-input>
          </div>

          <div class="aml_block aml_block--domain" v-if="valueLocal[i].domain !== customDomainText">
            <el-select
              v-model="valueLocal[i].domain"
              :class="{ 'child-has-error': error[i].domain }"
              @change="onDomainChange(i)"
              placeholder="Домен организации">
              <el-option
                v-for="(d, j) in domains"
                :key="`mail-domain-${j}`"
                :label="d"
                :value="d"/>
            </el-select>
          </div>

          <div
            class="aml_block aml_block--domain aml_block--custom-domain"
            @click="removeError(i)"
            v-show="valueLocal[i].domain === customDomainText">
            <el-input
              :ref="`customDomain${i}`"
              :class="{ 'child-has-error': error[i].customDomain }"
              @input="initChangeTimer(i)"
              v-model="valueLocal[i].customDomain">
            </el-input>
            <el-button
              class="aml_custom-domain-back"
              @click="onCustomDomainBackClick(i)"
              icon="el-icon-close"/>
          </div>

        </div>

        <div
          v-if="error[i].mail || error[i].domain || error[i].code"
          class="ait_message ait_message--error">
          {{ error[i].mail ? error[i].mail : (error[i].domain ? error[i].domain : '') }}
        </div>

        <div
          v-if="verifyVisible(i)"
          class="aml_approve_ama">
          <el-button
            @click="sendVerificationCode(i)"
            :class="{ 'not-active': btnSendInactiveTimer }"
            class="vivid-button ama_btn">
            Подтвердите e-mail *</el-button>
          <el-input
            class="ama_code"
            :class="{ 'child-has-error': error[i].code }"
            @focus="error[i].code = ''"
            v-model="valueLocal[i].code"
            placeholder="Введите полученный код"/>
          <el-tooltip
              class="ama_help"
              placement="top"
              :enterable="false"
              :open-delay="300">
            <div slot="content">После нажатия кнопки «Подтвердить e-mail»
              <br>вам будет выслано письмо с кодом, который нужно
              <br>ввести в данное поле.
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import axios from 'axios';
import approve from 'approvejs';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: { mail: '', domain: '', customDomain: '', code: '' },
      errorBase: { mail: '', domain: '', customDomain: '', code: '' },
      mailSource: null,
      organizations: [],
      customDomainText: 'свой домен',
      changeTimers: [],
      verifyVisibleInited: false,
      btnSendInactive: false,
      btnSendInactiveTimer: null,
    };
  },

  created() {
    // Add error messages
    this.validateMessages = Object.assign(
      this.validateMessages,
      {
        mail: 'Введите корректный адрес электронной почты!',
        busy: 'Этот адрес электронной почты уже занят!',
        code: 'Введите код подтверждения!',
      },
    );
  },

  computed: {

    domains() {
      const orgs = this.$store.getters['orgs/getOrgs'];
      const domains = [];
      domains.push(this.customDomainText);
      orgs.forEach((org) => {
        domains.push(org.Domain);
      });
      return domains;
    },

  },

  methods: {

    verifyVisible(i) {
      return this.verifyVisibleInited && this.options.verify
        && !this.error[i].mail && !this.error[i].domain && !this.error[i].customDomain
        && this.getValue() !== ''
        && this.mailSource !== (this.getValue()).mail;
    },

    initChangeTimer(i) {
      if (typeof this.changeTimers[i] !== 'undefined') {
        clearInterval(this.changeTimers[i]);
      }
      this.changeTimers[i] = setTimeout(() => {
        this.checkMailBusy(i);
      }, 500);
    },

    onDomainChange(i) {
      this.removeError(i);
      if (this.valueLocal[i].domain === this.customDomainText) {
        setTimeout(() => {
          this.$refs[`customDomain${i}`][0].focus();
        }, 300);
      } else {
        this.valueLocal[i].customDomain = '';
        this.checkMailBusy(i);
      }
    },

    checkMailBusy(i) {
      this.verifyVisibleInited = true;
      clearTimeout(this.btnSendInactiveTimer);
      this.btnSendInactiveTimer = null;

      // Prevent check if unique validator not set to true
      if (!this.options.unique
        || (this.mailSource && this.mailSource === (this.getValue()).mail)) return;

      const mail = this.valueLocal[i].mail;
      const domain = this.valueLocal[i].customDomain || this.valueLocal[i].domain;
      const full = `${mail}@${domain}`;

      if (this.options.verify && this.mailSource && full === this.mailSource) {
        this.removeError(i);
        return;
      }

      // Prevent check if domain or customDomain not filled
      if (
        this.valueLocal[i].mail === ''
        || this.valueLocal[i].domain === ''
        || (this.valueLocal[i].domain === this.customDomainText
           && this.valueLocal[i].customDomain === '')
      ) return;

      const result = approve.value(full, { email: true });
      if (!result.approved) {
        this.error[i].mail = this.validateMessages.mail;
        this.error[i].domain = this.validateMessages.mail;
        this.error[i].customDomain = this.validateMessages.mail;
      } else {
        this.removeError(i);
        axios.get('users/exist', { params: { mail: full } }).then((resp) => {
          if (resp.data) {
            this.error[i].mail = this.validateMessages.busy;
            this.error[i].domain = this.validateMessages.busy;
            this.error[i].customDomain = this.validateMessages.busy;
          } else {
            this.removeError(i);
          }
        });
      }
    },

    onCustomDomainBackClick(i) {
      this.valueLocal[i].domain = '';
      this.valueLocal[i].customDomain = '';
      this.removeError(i);
    },

    setValue(value) {
      const pts = value[0].split('@');
      this.valueLocal[0].mail = pts[0];
      if (this.domains.indexOf(pts[1]) > -1) {
        this.valueLocal[0].domain = pts[1];
      } else {
        this.valueLocal[0].domain = this.customDomainText;
        this.valueLocal[0].customDomain = pts[1];
      }
      this.mailSource = value;
    },

    getError() {
      // Validate required
      if (this.options.required) {
        this.valueLocal.forEach((value, i) => {
          if (this.error[i].mail || this.error[i].domain || this.error[i].customDomain) {
            return;
          }
          this.error[i].mail = (value.mail === '' ? this.validateMessages.required : '');
          if (
            (value.domain === '' || value.domain === this.customDomainText)
            && value.customDomain === ''
          ) {
            this.error[i].domain = this.validateMessages.required;
            this.error[i].customDomain = this.validateMessages.required;
          }
        });
      }
      // Validate verify code required
      if (this.options.verify
        && (this.mailSource && this.mailSource !== (this.getValue()).mail)
      ) {
        this.valueLocal.forEach((value, i) => {
          if (!this.verifyVisible(i) || this.error[i].mail
            || this.error[i].domain || this.error[i].customDomain
          ) {
            return;
          }
          this.error[i].code = value.code === '' ? this.validateMessages.code : '';
        });
      }
      // Validate is valid email
      this.valueLocal.forEach((value, i) => {
        if (
          this.error[i].mail || this.error[i].domain || this.error[i].customDomain
        ) return;
        const mail = this.valueLocal[i].mail;
        const domain = this.valueLocal[i].customDomain || this.valueLocal[i].domain;
        const full = `${mail}@${domain}`;
        const result = approve.value(full, { email: true });
        if (!result.approved) {
          this.error[i].mail = this.validateMessages.mail;
          this.error[i].domain = this.validateMessages.domain;
          this.error[i].customDomain = this.validateMessages.customDomain;
        }
      });
      this.updateValue();
      return this.error;
    },

    getValue() {
      // Return multiple values. No verification implemented with multiple values
      if (this.options && this.options.multiple) {
        const value = [];
        this.ValueLocal.forEach((v) => {
          if (this.options.verify) {
            if (v.mail && (v.domain || v.customDomain)) {
              value.push(`${v.mail}@${v.customDomain || v.domain}`);
            }
          }
        });
        return value;
      }
      // Return single value
      if (this.valueLocal[0].mail && this.valueLocal[0].domain) {
        const mail = `${this.valueLocal[0].mail}@${this.valueLocal[0].customDomain || this.valueLocal[0].domain}`;
        // Return single value if verify option enabled
        if (this.options.verify) {
          return {
            mail,
            code: this.valueLocal[0].code,
          };
        }
        // Return single value if verify option disabled
        return mail;
      }

      return '';
    },

    removeError(i) {
      if (this.error[i]) {
        this.error[i].mail = '';
        this.error[i].domain = '';
        this.error[i].customDomain = '';
        this.error[i].code = '';
      }
    },

    sendVerificationCode(i) {
      const value = this.getValue();
      const mail = Array.isArray(value) ? value[i] : value.mail;
      const btn = this.$el.querySelector('.ama_btn');
      btn.setAttribute('disabled', 'true');
      axios.get(`users/verify-mail/${mail}`).then((r) => {
        btn.removeAttribute('disabled');
        this.$message.closeAll();
        this.$message.success(r.data);
        this.btnSendInactiveTimer = setTimeout(() => {
          this.btnSendInactiveTimer = null;
        }, 5 * 60 * 1000);
      }).catch((e) => {
        btn.removeAttribute('disabled');
        this.$message.closeAll();
        const r = e.response;
        if (r.status === 403) {
          this.$message.error(r.data.message);
          this.btnSendInactive = true;
          if (this.btnSendInactiveTimer === null) {
            this.btnSendInactiveTimer = setTimeout(() => {
              this.btnSendInactiveTimer = null;
            }, r.data.time * 1000);
          }
        } else {
          this.$message.error(e.response.data);
        }
      });
    },

  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.app-mail_aml {

  .aml_block-wrap {
    @include clearfix;
    .aml_block {
      float: left;
      position: relative;
      &.aml_block--mail {
        width: 60%;
        .el-input__inner {
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
        }
        .el-input-group__append {
          border-right: 0;
          background: transparent;
          border-top-color: transparent;
          border-bottom-color: transparent;
          color: #fff;
        }
      }
      &.aml_block--domain {
        width: 40%;
      }
      .aml_custom-domain-back {
        border: none;
        background: transparent;
        position: absolute;
        right: 1px;
        top: 1px;
        bottom: 1px;
        width: 40px;
        padding: 0;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        .el-icon-close {
          color: #fff;
          opacity: .7;
          transition: opacity .3s;
        }
        &:hover {
          .el-icon-close {
            opacity: 1;
          }
        }
      }
      &.aml_block--custom-domain {
      }
    }
  }

  .aml_approve_ama {
    text-align: center;
    padding: 20px 0 0;
    .ama_btn {
      height: 40px;
      padding: 2px 0 0;
      width: 250px;
      line-height: 0;
      display: block;
      margin: 0 auto 10px;
      transition: opacity .3s;
      &:focus,
      &:hover {
        color: #fff;
      }
      &.not-active {
        opacity: .3;
      }
    }
    .ama_code {
      width: 220px;
    }
    .ama_help {
      margin-left: 5px;
    }
  }

  @media (max-width: 500px) {
    .aml_block-wrap {
      .aml_block {
        float: none;
        &.aml_block--mail {
          width: 100%;
          margin-bottom: 10px;
          .el-input-group__append {
            float: none;
            padding: 0 10px 0 15px;
          }
        }
        &.aml_block--domain {
          width: 100%;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppMail.vue